import { addDictionaryExtraLine, dictionaryComplexFromJsonArr, TwinDictionary } from '../../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { CustomDetailsTextFieldTPV} from '../SpecificComponents'
import { ComponentTabObject } from '../../../../../../../utils/hooks/useTabLogic'
import { memo, useCallback, useEffect, useMemo, useState } from 'react'
import { twinFetchPostJSON } from '../../../../../../../utils/globals/data'
import { stringMatchWithSearch } from '../../../../../../../utils/globals/search'
import { CustomSelectWithSearchBar } from '../../../../../../../forms/CustomSelect'
import { EditCardTabsHorizontalWithoutLinks } from '../../../../../../../baseComponents/EditCardTabs'
import SearchBar from '../../../../../../../baseComponents/SearchBar'
import { getAllSpecificPriceRules } from '../../../../../../../utils/reducers/getters'
import { connect, ConnectedProps } from 'react-redux'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import { CategoriesPayload } from '../../../../../../../utils/reducers/products/categories'
import { SpecificPriceRulesPayload } from '../../../../../../../utils/reducers/products/specificPriceRules'
import { ProductModelType } from '@teinor/erp/types/company/product'
import { addAntiUnsaveElement } from '../../../../../../../utils/reducers/reduxDispatch'
import { InputTableURLsTable } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { ProductExtendedTyLong } from '../../../../../../../specificComponents/Product/types'
import useEditDeleteModal from '../../../../../../../utils/hooks/useEditDeleteModal'
import { OnSubmit } from '../../../../../../../forms/TwinForm/types'
import { TPVOrderData } from '../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/types'
import { memoChecker } from '../../../../../../../utils/globals/components'
import ModalComplexProductVariantsOrder from '../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalComplexProductVariantsOrder'

interface ProductCategoriesTPVDSBProps extends ProductCategoryTabsProps { 
    title: string
    CustomerId: number | null
    OrderId: number
}

const ProductCategoriesTPVDSB: React.FC<ProductCategoriesTPVDSBProps> = memo(({ title, ...rest }) => {
    return (
        <div className='flex flex-auto overflow-hidden flex-col products_list_main'>
            <h3 className='pb-15'>{title}</h3>
            <ProductCategoryTabs {...{ ...rest }} />
        </div>
    )
}, (oldProps, nextProps) => memoChecker(oldProps, nextProps, ['CustomerId', 'OrderId']))

interface ProductCategoryTabsProps extends ProductCategoryTabsLogicProps {
    inputTableURLs: InputTableURLsTable
    getCompleteData: (prop1?: any, prop2?: any) => Promise<void>
    completeData: TPVOrderData | null
    addTicketProduct: (product: ProductModelType) => Promise<void>
}

const ProductCategoryTabs: React.FC<ProductCategoryTabsProps> = ({...rest}) => {
    const { setTabActive, tabActive, data, filterSubCategories, setFilterSubCategories } = useProductCategoryTabsLogic()

    const tabs: ComponentTabObject = {
        'allCategories': {
            component: () => <ProductsListContent showCategorySelector={false} extraWhereParams={{ productType: { '$or': [0, 3, 4] } }} {...{...rest}} />,
            text: 'Todas las categorías',
        } 
    }

    if (data) {
        for (const element of data) {
            tabs[element?.["CategoryLangs.name"]] = {
                component: () => <ProductsListContent value={element?.id} showCategorySelector={true} extraWhereParams={{ 'CategoriesProducts.CategoryId': filterSubCategories || element?.id }} {...{ setFilterSubCategories }} {...{ ...rest }} />,
                text: element?.name,
            }
        }
    }

    return (
        <EditCardTabsHorizontalWithoutLinks tabs={tabs} tab={tabActive} onClick={(value) => { setTabActive(value); setFilterSubCategories('') }} className=' flex_tabs' />
    )
}

interface ProductCategoryTabsLogicProps { }

const useProductCategoryTabsLogic = () => {
    const [tabActive, setTabActive] = useState('activity')
    const [filterSubCategories, setFilterSubCategories] = useState('')
    const [data, setData] = useState<any | null>(null)

    const getData = useCallback(async () => {
        const extraWhereParams = { 'Category.CategoryId': '1', categoryMaterialType: '0' }
        const result = await twinFetchPostJSON('/api/app/product/category/getAllCategories', { where: extraWhereParams })
        if (result) {
            setData(result)
        }
    }, [setData])

    useEffect(() => {
        getData()
    }, [getData])

    return { tabActive, setTabActive, data, filterSubCategories, setFilterSubCategories }
}

interface ProductsListContentProps extends ProductsListContentLogicProps { 
    showCategorySelector: boolean
    setFilterSubCategories?: React.Dispatch<React.SetStateAction<string>>
    value?: string
    completeData: TPVOrderData | null
    inputTableURLs: InputTableURLsTable
}

const ProductsListContent: React.FC<ProductsListContentProps> = ({ extraWhereParams, showCategorySelector, value, setFilterSubCategories, ...rest }) => {
    const { t } = useTwinTranslation()
    const { generalSearch, setGeneralSearch, data, addProductToSellTicket, openModal, setOpenModal, myOnSubmitModalComplex } = useProductsListContentLogic({ extraWhereParams, ...rest })
    const renderThis: JSX.Element[] = []
    let text = t('NoProductsInThisCategory', 'No hay productos en esta categoría')
    if (data) {
        for (const element of data) {
            const includesSearch = stringMatchWithSearch(generalSearch, (element?.reference || '')) || stringMatchWithSearch(generalSearch, element?.['ProductLangs.name'])
            const imageUrl = element?.['ProductImages.url'] || ''
            if (includesSearch) {
                renderThis.push(<SingleCardProduct url={imageUrl} name={element?.['ProductLangs.name']} reference={element?.reference || ''} id={String(element?.id)} addProductToSellTicket={() => addProductToSellTicket(element)} key={element.id} />)
            } else {
                text = t('NoResultsForYourSearch', 'No hay resultados para tu búsqueda')
            }
        }
    }
    if (rest.completeData?.header?.readOnly) {
        rest.inputTableURLs.createData[1].OrderId = undefined
    }
    return (
        <div className='flex flex-col flex-auto h-1'>
            <SearchProductHeader showCategorySelector={showCategorySelector} value={value || ''} {...{setFilterSubCategories, setGeneralSearch, generalSearch}} />
            {renderThis.length ? 
                <div className='grid pr-5 overflow-auto gap-15 mt-5 products_list_content'>
                    {renderThis}
                </div>
                : <div className='regular16 text-center mt-30 text-gray-9D pl-1'>{text}</div>
            }
            {openModal?.type === 'edit' ? <ModalComplexProductVariantsOrder getCompleteData={rest.getCompleteData} headerData={rest.completeData?.header || {}} onSubmit={myOnSubmitModalComplex} orderURLs={rest.inputTableURLs as any} setOpened={() => setOpenModal(null)} allRowData={openModal?.allRowData}/> : null}
        </div>
    )
}

interface ProductsListContentLogicProps {
    extraWhereParams?: TwinDictionary
    getCompleteData: (prop1?: any, prop2?: any) => Promise<void>
    addTicketProduct: (product: ProductModelType) => Promise<void>
}
const useProductsListContentLogic = ({ extraWhereParams, getCompleteData, addTicketProduct }: ProductsListContentLogicProps) => {
    const [generalSearch, setGeneralSearch] = useState<string>('')
    const [data, setData] = useState<ProductExtendedTyLong[] | null>(null)
    const { openModal, setOpenModal } = useEditDeleteModal()

    const specificPriceRules = getAllSpecificPriceRules()
    const defaultSpecificPriceRuleId = useMemo(() => {
        const specificPriceRulesSorted = specificPriceRules?.arrSorted || []
        return specificPriceRulesSorted?.[0]?.id
    }, [specificPriceRules?.arrSorted])
    const myExtraParamsJustForEffect = JSON.stringify(extraWhereParams)

    const getData = useCallback(async () => {
        const myExtraWhereParams = JSON.parse(myExtraParamsJustForEffect || '{}')
        // Virtualitzar here
        const myExtraWhereParamsPlus = { ...myExtraWhereParams, active: true, SpecificPriceRuleId: defaultSpecificPriceRuleId }
        const result = await twinFetchPostJSON('/api/app/product/getAllProductsComplete', {
            limit: 30,
            offset: 0,
            orderToParse: [["id", "desc"]],
            where: myExtraWhereParamsPlus
        })
        if (result) {
            setData(result)
        }
    }, [setData, myExtraParamsJustForEffect, defaultSpecificPriceRuleId])

    const addProductToSellTicket = useCallback(async (product: ProductModelType) => {
        await addAntiUnsaveElement(['sellTicket', '{}'])
        if (product.isVariantProduct && !product.ProductId) {
            setOpenModal({ type: 'edit', allRowData: { ...product, ProductId: product.id } })
        } else {
            await addTicketProduct(product)
        }
    }, [setOpenModal, addTicketProduct])

    const myOnSubmitModalComplex: OnSubmit = useCallback(async (res) => {
        const result = await res.json()
        await getCompleteData(result?.[0]?.OrderId, true)
    }, [getCompleteData])
    
    useEffect(() => {
        getData()
    }, [getData])

    return { generalSearch, setGeneralSearch, data, addProductToSellTicket, openModal, setOpenModal, myOnSubmitModalComplex }
}

interface SingleCardProductProps {
    id: string
    name: string
    url: string
    reference: string
    addProductToSellTicket: () => Promise<void>
}

const SingleCardProduct: React.FC<SingleCardProductProps> = ({ id, name, reference, url, addProductToSellTicket }) => {
    return (
        <div className='flex flex-col rounded-md border border-gray-EE single_product cursor-pointer' onClick={addProductToSellTicket}>
            <CustomDisplayProductImageCategoryTPV name={name} id={'singleProduct_' + id} url={url}/>
            <div className='flex flex-col flex-wrap p-6'>
                <CustomDetailsTextFieldTPV className='mb-2 regular12 twin_elipsis' data={name} />
                <CustomDetailsTextFieldTPV className='mb-2 regular12 twin_elipsis' data={reference} />
            </div>
        </div>
    )
}

interface SearchProductHeaderProps extends SearchProductHeaderLogicProps {
    generalSearch: string
    setGeneralSearch: React.Dispatch<React.SetStateAction<string>>
    setFilterSubCategories?: React.Dispatch<React.SetStateAction<string>>
    showCategorySelector: boolean
}

const SearchProductHeader: React.FC<SearchProductHeaderProps> = ({ generalSearch, setGeneralSearch, setFilterSubCategories, value, showCategorySelector }) => {
    const { t } = useTwinTranslation()
    const { data } = useSearchProductHeaderLogic({ value })
    const dictProductCategories = addDictionaryExtraLine(dictionaryComplexFromJsonArr(data || []))
    return (
        <div className='flex flex-row flex-wrap gap-y-15 gap-x-60 justify-between mb-10 mt-10'>
            <SearchBar className='search_bar_table flex items-end mt-16' placeholder={t('searchDots', 'Buscar...')} searchValue={generalSearch} onChange={(value) => setGeneralSearch(value)} />
            {showCategorySelector && data ?
                <CustomSelectWithSearchBar sortItems={true} className='flex-auto max-w-300' label={t('showCategories', 'Mostrar categorías')} items={dictProductCategories} fieldName={'name'} onChange={setFilterSubCategories} />
                : null
            }
        </div>
    )
}

interface SearchProductHeaderLogicProps {
    value: string
}

const useSearchProductHeaderLogic = ({ value }: SearchProductHeaderLogicProps) => {
    const [data, setData] = useState<any | null>(null)
    const getData = useCallback(async () => {
        const extraWhereParams = { 'Category.CategoryId': value }
        const result = await twinFetchPostJSON('/api/app/product/category/getAllCategories', {
            where: extraWhereParams
        })
        if (result) {
            setData(result)
        }
    }, [setData, value])

    useEffect(() => {
        if (value) {
            getData()
        }
    }, [getData, value])

    return {data}
}

interface CustomDisplayProductImageCategoryTPVProps {
    url: string
    id: string
    name: string
}

export const CustomDisplayProductImageCategoryTPV: React.FC<CustomDisplayProductImageCategoryTPVProps> = ({ url, id, name }) => {
    return (
        <div className='relative flex justify-center items-center product_image_parent'>
            <img src={url || '/no-image-small.png'} alt={name || 'product_image'} className='object-cover flex items-center justify-center product_image' data-tooltip-id={'product_image_' + id} />
        </div>
    )
}

const categoriesDispatch = {
    setCategories: (payload: CategoriesPayload) => ({ type: 'CHANGE_CATEGORIES', payload }),
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
}

export type ReduxCategories = ConnectedProps<typeof categoriesConnect>
const mapCategoriesConnector = (state: AllReduxPayloads) => ({ categories: state.categories, specificPriceRules: state.specificPriceRules })
const categoriesConnect = connect(mapCategoriesConnector, categoriesDispatch)

const categoriesConnectLoading = withLoading(ProductCategoriesTPVDSB, [{ fetchUrl: '/api/app/product/category/getAllCategories', propName: 'categories', setFunctionName: 'setCategories' }, { fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }])

const ProductCategoriesTPVDSBConnect = categoriesConnect(categoriesConnectLoading);

export default ProductCategoriesTPVDSBConnect
